<template lang="pug">
  .container
    .search
      .search-field.long
        el-input(:placeholder="searchPlaceholder" v-model='searchTerm' @keyup.native.enter="doSearch" :on-icon-click='doSearch' icon="search")
      .search-field(v-if='$slots.extraSearch')
        slot(name='extraSearch')

    .actions
      .action-item
        slot(name='action')

</template>

<script>
export default {
  props: {
    onSearch: {
      type: Function,
      required: true
    },
    searchPlaceholder: {
      type: String,
      default: "Search..."
    }
  },
  data() {
    return {
      searchTerm: ""
    };
  },
  methods: {
    doSearch() {
      this.onSearch(this.searchTerm);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/mixins.scss";

.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  @include MQ(S) {
    flex-direction: column;
    align-items: flex-start;
  }
}

.search {
  display: flex;
  align-items: center;
  margin-right: 10px;
  @include MQ(S) {
    flex-wrap: wrap;
  }
}

.search-field {
  margin-right: 10px;
  flex: 0 0 200px;

  &.long {
    flex: 0 0 300px;
    @include MQ(S) {
      flex-basis: 100%;
      margin-bottom: 10px;
    }
  }
}

.actions {
  flex: 0 0 auto;
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  .action-item {
    margin-left: 10px;
    display: flex;
    align-items: center;

    :global(.el-button) {
      margin-left: 5px;
    }
  }
  @include MQ(S) {
    margin-left: 0;
    flex-basis: auto;
    min-width: 100%;
    margin-top: 10px;
    flex-direction: column;
    align-items: flex-start;
    .action-item {
      margin-left: 0;
      a {
        margin-right: 10px;
      }
    }
  }
}
</style>
